import { CreatorSort } from 'lib/types/filters';

export const creatorSortOptions: { [K in CreatorSort]?: string } = {
  trendingCreators: 'Trending Creators',
  currentEngagements: 'Total Engagements',
  mostRecentCredit: 'Most Recent Credit',
  mostCredits: 'Most Credits',
  newestCreators: 'Newest Creators',
  votes: 'Most Upvotes',
  submissionDate: 'Date Added to List',
};

export const DEFAULT_PAGE_SIZE = 25;

export const ANONYMOUS_USER_PAGE_SIZE = 10;

export const LIST_PAGE_SIZE = 50;

export const MAX_CREATOR_SIZE = 50;

export const creatorRelations = '[userPermissions, location, hiddenRoles, defaultRole, postingAccounts.[networkAccount]]';
